<template>
  <div class="customer-list">
    <div class="list-header">
      <div class="header-actions">
        <el-button
          type="primary"
          size="small"
          @click="loadCustomerList"
          :loading="loading"
          icon="el-icon-refresh"
        >
          加载最新数据
        </el-button>
        <el-button
          type="primary"
          size="small"
          @click="editorNew(customerList[0])"
          :loading="loading"
          icon="el-icon-shopping-cart-2"
        >
          代客下单
        </el-button>
        <el-button
          type="primary"
          size="small"
          @click="showReminderDialog(customerList[0])"
          :disabled="customerList.length === 0"
          icon="el-icon-bell"
        >
          联系提醒
        </el-button>
      </div>
    </div>
    <!-- 加载状态 -->
    <div v-if="loading" class="loading-container">
      <i class="el-icon-loading"></i>
      <p>正在加载客户数据...</p>
    </div>

    <!-- 空状态 -->
    <div v-else-if="customerList.length === 0" class="empty-container">
      <el-empty description="暂无客户数据" />
    </div>

    <!-- 客户列表 -->
    <div v-else class="customer-container">
      <div class="customer-grid">
        <div
          v-for="customer in customerList"
          :key="customer.id || customer.userId"
          class="customer-card"
        >
          <div class="customer-info">
            <div class="customer-name">
              客户备注：
              {{ customer.remark || customer.idCardName || "未知客户" }}
            </div>
            <!-- 直接显示详情信息 -->
            <div class="customer-detail-inline">
              <div v-if="customer.corpName" class="detail-item">
                <span class="detail-label">企业名称：</span>
                <span class="detail-value">{{ customer.corpName }}</span>
              </div>
              <div
                v-if="customer.ser && customer.ser.username"
                class="detail-item"
              >
                <span class="detail-label">专属客服：</span>
                <span class="detail-value">{{ customer.ser.username }}</span>
              </div>
              <div class="detail-item detail-item-tags">
                <span class="detail-label">客户标签：</span>
                <div class="detail-value tag-list">
                  <template v-if="assignedTags.length > 0">
                    <el-tag
                      v-for="tag in assignedTags"
                      :key="tag.tagId || tag.id"
                      :type="getTagType(tag)"
                      :effect="tag.enabled === false || tag.deleted === true ? 'plain' : 'light'"
                      size="small"
                      class="customer-tag-chip"
                    >
                      {{ tag.tagName || tag.name }}
                    </el-tag>
                  </template>
                  <span v-else class="tag-empty">暂无标签</span>
                  <el-button
                    type="primary"
                    size="mini"
                    class="tag-edit-btn"
                    :loading="tagListLoading"
                    @click.stop="openTagEditor"
                  >
                    编辑标签
                  </el-button>
                </div>
              </div>
              <!-- 默认收货地址信息 -->
              <template v-if="customer.defaultAddress">
                <div class="detail-item">
                  <span class="detail-label">收件人：</span>
                  <span class="detail-value">{{
                    customer.defaultAddress.idCardName
                  }}</span>
                </div>
                <div class="detail-item">
                  <span class="detail-label">收件号码：</span>
                  <span class="detail-value">{{
                    customer.defaultAddress.receiverTel
                  }}</span>
                </div>
                <div class="detail-item">
                  <span class="detail-label">身份证号：</span>
                  <span class="detail-value">{{
                    customer.defaultAddress.idCardNo
                  }}</span>
                </div>
                <div class="detail-item">
                  <span class="detail-label">收货地址：</span>
                  <span class="detail-value"
                    >{{ customer.defaultAddress.province
                    }}{{ customer.defaultAddress.city
                    }}{{ customer.defaultAddress.town }}
                    {{ customer.defaultAddress.receiverAddr }}</span
                  >
                </div>
                <div class="detail-item copy-action">
                  <el-button
                    type="primary"
                    size="mini"
                    @click="copyReceiverInfo(customer.defaultAddress)"
                  >
                    复制收件信息
                  </el-button>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 为用户下单 - 自定义全屏弹窗 -->
    <div v-if="dialogVisible" class="custom-modal-overlay">
      <div class="custom-modal custom-modal-large">
        <div class="custom-modal-header">
          <span class="custom-modal-title">代客下单</span>
          <span class="custom-modal-close" @click="handleCloseOrderDialog"
            >&times;</span
          >
        </div>
        <div class="custom-modal-body">
          <el-form :model="info" label-width="60px">
            <el-form-item label="地址列表">
              <div
                class="select-wrapper"
                @touchstart="handleAddressSelectTouch"
              >
                <el-select
                  ref="addressSelectRef"
                  clearable
                  filterable
                  @change="getaddinfo"
                  style="width: 100%"
                  v-model="addressId"
                  placeholder="请选择地址"
                  popper-class="address-select-dropdown"
                >
                  <el-option
                    clearable
                    v-for="item in addressList"
                    :key="item.id"
                    :label="getFullAddressLabel(item)"
                    :value="item.id"
                  >
                    <div class="address-option-full">
                      <div class="address-row">
                        {{ item.idCardName }} | {{ item.receiverTel }} |
                        {{ item.idCardNo }}
                      </div>
                      <div class="address-row address-detail">
                        {{ item.province }}{{ item.city }}{{ item.town
                        }}{{ item.receiverAddr }}
                      </div>
                    </div>
                  </el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item label="姓名">
              <el-input
                style="font-size: 14px !important; font-weight: 500"
                v-model="info.idCardName"
              ></el-input>
            </el-form-item>
            <el-form-item label="电话">
              <el-input
                style="font-size: 14px !important; font-weight: 500"
                @blur="isPhone"
                v-model="info.phone"
              ></el-input>
            </el-form-item>
            <el-form-item label="身份证号">
              <el-input
                style="font-size: 14px !important; font-weight: 500"
                @blur="isCard"
                v-model="info.idCardNo"
              ></el-input>
            </el-form-item>
            <el-form-item label="省市区">
              <div class="cascader-wrapper" @touchstart="handleCascaderTouch">
                <el-cascader
                  ref="cascaderRef"
                  @change="getaddInfo"
                  :props="{ value: 'id', label: 'name', children: 'children' }"
                  clearable
                  filterable
                  v-model="addvalue"
                  :options="addoptions"
                  placeholder="省市区"
                  style="
                    font-size: 14px !important;
                    font-weight: 500;
                    width: 100%;
                  "
                ></el-cascader>
              </div>
            </el-form-item>
            <el-form-item label="详细地址">
              <el-input
                style="font-size: 14px !important"
                v-model="info.address"
              ></el-input>
            </el-form-item>
            <el-form-item v-if="isrequireIdCard" label="身份证正面">
              <ImageUpload
                style="display: flex; flex-wrap: wrap"
                v-model="info.frontImage"
                :isShowTip="false"
                :isShowTip1="false"
                :limit="1"
                :fileSize="5"
                :fileType="['png', 'jpg', 'jpeg']"
              />
            </el-form-item>
            <el-form-item v-if="isrequireIdCard" label="身份证人像面">
              <ImageUpload
                style="display: flex; flex-wrap: wrap"
                v-model="info.backImage"
                :isShowTip="false"
                :isShowTip1="false"
                :limit="1"
                :fileSize="5"
                :fileType="['png', 'jpg', 'jpeg']"
              />
            </el-form-item>
            <el-form-item v-if="isrequireIdCard" label="手持身份证照片">
              <ImageUpload
                style="display: flex; flex-wrap: wrap"
                v-model="info.handHeldImage"
                :isShowTip="false"
                :isShowTip1="false"
                :limit="1"
                :fileSize="5"
                :fileType="['png', 'jpg', 'jpeg']"
              />
            </el-form-item>
            <el-form-item label="商品">
              <el-select
                @change="getshopinfo"
                style="width: 100%"
                v-model="info.goodsId"
                :filter-method="searchSelectGoods"
                :disabled="isGoodsSelectDisabled"
                filterable
                placeholder="请选择商品、关键词查询、sku编码精确查询"
              >
                <el-option
                  clearable
                  v-for="(item, index) in shopOptions"
                  :key="`goods-${item.id}-${index}`"
                  :label="getGoodsLabel(item)"
                  :value="item.id"
                >
                  <div class="goods-option-full">
                    <div class="goods-row">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        :content="item.subTitle || '无副标题'"
                        placement="top"
                      >
                        <span
                          class="goods-content"
                          :style="{
                            color: item.eff == '0' ? '#fd0000' : '#3cb500',
                          }"
                          >{{ item.title }}</span
                        >
                      </el-tooltip>
                    </div>
                  </div>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="info.goodsId" label="商品信息">
              <el-table :data="goodsInfo" style="width: 100%">
                <el-table-column
                  prop="mainImg"
                  label="主图"
                  width="200"
                  align="center"
                >
                  <template slot-scope="scope">
                    <img
                      :src="scope.row.mainImg.split(',')[0]"
                      alt=""
                      class="tableImg"
                    />
                  </template>
                </el-table-column>
                <el-table-column prop="title" label="商品名称" align="center" />
                <el-table-column
                  prop="price"
                  label="价格"
                  width="60"
                  align="center"
                />
                <el-table-column
                  prop="requireIdCard"
                  label="是否需要身份证照片"
                  align="center"
                >
                  <template slot-scope="scope">
                    <p v-if="scope.row.requireIdCard == 0">否</p>
                    <p v-if="scope.row.requireIdCard == 1">是</p>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="retailSku"
                  label="商品编码"
                  align="center"
                />
              </el-table>
            </el-form-item>
            <el-form-item>
              <span slot="label"
                >预设下单时间<el-tooltip
                  content="客户要求指定日期发货时选择；若无要求，可不选择"
                  placement="top"
                  ><i
                    class="el-icon-question"
                    style="margin-left: 4px"
                  ></i></el-tooltip
              ></span>
              <el-date-picker
                v-model="info.orderTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm:ss"
                placeholder="请选择预设下单时间"
                clearable
                style="width: 100%"
                :picker-options="preOrderPickerOptions"
              />
            </el-form-item>
            <el-form-item>
              <el-button
                :disabled="btnisfell"
                type="primary"
                @click="onSubmit"
                >{{ orderActionLabel }}</el-button
              >
              <el-button @click="close">取消</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>

    <!-- 联系客户提醒弹窗 - 自定义全屏弹窗 -->
    <div v-if="reminderDialogVisible" class="custom-modal-overlay">
      <div class="custom-modal">
        <div class="custom-modal-header">
          <span class="custom-modal-title">设置联系提醒</span>
          <span class="custom-modal-close" @click="handleCloseReminderDialog"
            >&times;</span
          >
        </div>
        <div class="custom-modal-body">
          <div v-if="selectedCustomerForReminder" class="reminder-form">
            <div class="customer-info-header">
              <div class="customer-avatar-small">
                <img
                  v-if="selectedCustomerForReminder.avatar"
                  :src="selectedCustomerForReminder.avatar"
                  :alt="
                    selectedCustomerForReminder.remark ||
                    selectedCustomerForReminder.idCardName
                  "
                />
                <div v-else class="avatar-placeholder-small">
                  {{
                    getAvatarText(
                      selectedCustomerForReminder.remark ||
                        selectedCustomerForReminder.idCardName
                    )
                  }}
                </div>
              </div>
              <div class="customer-info-text">
                <div class="customer-name-small">
                  {{
                    selectedCustomerForReminder.remark ||
                    selectedCustomerForReminder.idCardName ||
                    "未知客户"
                  }}
                </div>
              </div>
            </div>

            <el-form
              :model="reminderForm"
              :rules="reminderRules"
              ref="reminderForm"
              label-width="100px"
              class="reminder-form-content"
            >
              <el-form-item label="客户备注" prop="customerRemark">
                <el-input
                  v-model="reminderForm.customerRemark"
                  placeholder="请输入客户备注"
                  :maxlength="100"
                  show-word-limit
                />
              </el-form-item>
              <el-form-item label="提醒时间" prop="reminderTime" required>
                <el-date-picker
                  v-model="reminderForm.reminderTime"
                  type="datetime"
                  placeholder="选择提醒时间"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :picker-options="pickerOptions"
                  style="width: 100%"
                />
              </el-form-item>
              <el-form-item label="提醒内容" prop="noticeContent" required>
                <el-input
                  v-model="reminderForm.noticeContent"
                  type="textarea"
                  :rows="4"
                  placeholder="请输入提醒内容"
                  :maxlength="200"
                  show-word-limit
                />
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div class="custom-modal-footer">
          <el-button @click="handleCloseReminderDialog">取 消</el-button>
          <el-button
            type="primary"
            @click="submitReminder"
            :loading="reminderSubmitting"
            >确 定</el-button
          >
        </div>
      </div>
    </div>

    <!-- 客户标签编辑弹窗 - 自定义全屏弹窗 -->
    <div v-if="tagDialogVisible" class="custom-modal-overlay">
      <div class="custom-modal">
        <div class="custom-modal-header">
          <span class="custom-modal-title">编辑客户标签</span>
          <span class="custom-modal-close" @click="handleCloseTagDialog"
            >&times;</span
          >
        </div>
        <div class="custom-modal-body">
          <el-form label-width="80px">
            <el-form-item label="客户">
              <span class="tag-dialog-customer">
                {{
                  customerList.length > 0
                    ? customerList[0].remark ||
                      customerList[0].idCardName ||
                      "未知客户"
                    : ""
                }}
              </span>
            </el-form-item>
            <el-form-item label="标签">
              <el-select
                v-model="selectedTagIds"
                multiple
                filterable
                collapse-tags
                clearable
                :loading="tagOptionsLoading"
                :filter-method="filterTagOptions"
                placeholder="请选择标签（可搜索）"
                style="width: 100%"
                popper-class="tag-select-dropdown"
              >
                <el-option
                  v-for="opt in tagOptions"
                  :key="opt.tagId || opt.id"
                  :label="opt.tagName || opt.name"
                  :value="opt.tagId || opt.id"
                />
              </el-select>
              <div class="tag-dialog-hint">
                提交后将覆盖当前客户的全部标签
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div class="custom-modal-footer">
          <el-button @click="handleCloseTagDialog">取 消</el-button>
          <el-button
            type="primary"
            @click="submitCustomerTags"
            :loading="tagSubmitting"
            >确 定</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getCustomerInfo,
  receiverList,
  selectReplaceGoodslist,
  replaceTheOrder,
  savePreOrder,
  getareaLevel3,
  addLinkAlert,
  addReceiver,
  clearCustomerInfoCache,
  getCustomerTagOptions,
  getCustomerTagList,
  updateCustomerTags,
} from "@/api/wechat";
import ImageUpload from "@/components/ImageUpload";

export default {
  name: "CustomerList",
  components: {
    ImageUpload,
  },
  props: {
    corpId: {
      type: String,
      default: "",
    },
    qwUserId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      loading: false,
      customerList: [],
      addressList: [], //收货列表
      shopOptions: [], //商品列表
      dialogVisible: false,
      isrequireIdCard: false, //判断是否需要身份证
      goodsInfo: [], //商品信息
      retailUserId: "wmYz8TLgAACtKePWIprb4g7-Dy5Tlsqg", //零售用户ID
      lookaddShow: false,
      addinfo: {
        idCardNo: "",
        idCardName: "",
        receiverTel: "",
        pctIds: "",
        province: "",
        city: "",
        town: "",
        receiverAddr: "",
        retailUserId: "",
      },
      info: {
        idCardNo: "", //证件号码
        idCardName: "", //证件名
        phone: "", //电话
        pctIds: "", //地址id
        province: "", //省
        city: "", //市
        town: "", //区
        address: "", //详细地址
        frontImage: "", //正面
        backImage: "", //反面
        handHeldImage: "", //照片
        goodsId: "", //商品id
        paymentId: "",
        orderTime: "", //预设下单时间
      },
      addressId: null,
      addoptions: [], //三级地址列表
      addvalue: "",
      btnisfell: false,
      // 联系提醒相关数据
      reminderDialogVisible: false,
      selectedCustomerForReminder: null,
      reminderSubmitting: false,
      reminderForm: {
        customerRemark: "",
        reminderTime: "",
        noticeContent: "",
      },
      reminderRules: {
        reminderTime: [
          { required: true, message: "请选择提醒时间", trigger: "change" },
        ],
        noticeContent: [
          { required: true, message: "请输入提醒内容", trigger: "blur" },
          {
            min: 1,
            max: 200,
            message: "提醒内容长度在 1 到 200 个字符",
            trigger: "blur",
          },
        ],
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7; // 不能选择今天之前的日期
        },
      },
      preOrderPickerOptions: {
        disabledDate(time) {
          const startOfToday = new Date();
          startOfToday.setHours(0, 0, 0, 0);
          return time.getTime() < startOfToday.getTime();
        },
      },
      // 客户标签相关
      tagDialogVisible: false,
      tagSubmitting: false,
      tagOptionsLoading: false,
      tagListLoading: false,
      tagOptions: [], // 可选标签（已启用）—— 当前展示用，受过滤影响
      allTagOptions: [], // 可选标签（已启用）—— 完整列表，用于本地过滤恢复
      assignedTags: [], // 当前已分配标签（含禁用/删除的用于展示）
      selectedTagIds: [], // 弹窗中选中的标签ID
    };
  },
  computed: {
    // 判断商品选择是否应该禁用（四个参数必须全部有值）
    isGoodsSelectDisabled() {
      const { idCardNo, province, city, town } = this.info;
      return !(idCardNo && province && city && town);
    },
    orderActionLabel() {
      return this.info.orderTime ? "预下单" : "立即下单";
    },
  },
  mounted() {
    this.loadCustomerList();
    this.getthreearea();
  },
  watch: {
    corpId() {
      this.loadCustomerList();
    },
    qwUserId() {
      this.loadCustomerList();
    },
  },
  beforeDestroy() {
    // 组件销毁时的清理工作
  },
  methods: {
    // 获取服务端用户ID（客服ID）- 优先从本地存储获取
    getServerUserId() {
      // 优先从本地存储获取
      const localServerUserId = localStorage.getItem("wechat_serverUserId");
      if (localServerUserId) {
        return localServerUserId;
      }

      // 备用：从store获取
      const serverUserId =
        this.$store.state.wechat?.debugInfo?.getUserIdApi?.response;
      return serverUserId || null;
    },

    async waitForCustomerContext(timeout = 8000, interval = 300) {
      const startTime = Date.now();

      return new Promise((resolve) => {
        const check = () => {
          const context = {
            corpId: this.corpId,
            qwUserId: this.qwUserId,
            serverUserId: this.getServerUserId(),
          };

          if (context.corpId && context.qwUserId && context.serverUserId) {
            resolve(context);
            return;
          }

          if (Date.now() - startTime >= timeout) {
            resolve(context);
            return;
          }

          setTimeout(check, interval);
        };

        check();
      });
    },

    //为客户下单弹窗
    editorNew(row) {
      this.btnisfell = false;
      this.info = {
        idCardNo: "", //证件号码
        idCardName: "", //证件名
        phone: "", //电话
        pctIds: "", //地址id
        province: "", //省
        city: "", //市
        town: "", //区
        address: "", //详细地址
        frontImage: "", //正面
        backImage: "", //反面
        handHeldImage: "", //照片
        goodsId: "", //商品id
        orderTime: "", //预设下单时间
      };

      this.dialogVisible = true;
      this.retailUserId = row.retailUserId;
      this.info.paymentId = row.retailUserId;

      // 如果有默认地址，则回显默认地址
      if (row.defaultAddress) {
        const defaultAddr = row.defaultAddress;
        this.info.idCardNo = defaultAddr.idCardNo; //证件号码
        this.info.idCardName = defaultAddr.idCardName; //证件名
        this.info.pctIds = defaultAddr.pctIds; //地址id
        this.info.province = defaultAddr.province; //省
        this.info.city = defaultAddr.city; //市
        this.info.town = defaultAddr.town; //区
        this.info.address = defaultAddr.receiverAddr; //详细地址
        this.info.phone = defaultAddr.receiverTel; //电话
        this.addressId = defaultAddr.id;
        if (defaultAddr.pctIds) {
          this.addvalue = defaultAddr.pctIds.split(",").map(Number);
        }
        this.addinfo.idCardNo = defaultAddr.idCardNo; //证件号码
        this.addinfo.idCardName = defaultAddr.idCardName; //证件名
        this.addinfo.receiverTel = defaultAddr.receiverTel; //电话
        this.addinfo.pctIds = defaultAddr.pctIds; //地址id
        this.addinfo.province = defaultAddr.province; //省
        this.addinfo.city = defaultAddr.city; //市
        this.addinfo.town = defaultAddr.town; //区
        this.addinfo.receiverAddr = defaultAddr.receiverAddr; //详细地址
      }
      this.checkAndGetGoodsList();
    },
    close() {
      this.dialogVisible = false;
      this.info = {
        idCardNo: "", //证件号码
        idCardName: "", //证件名
        phone: "", //电话
        pctIds: "", //地址id
        province: "", //省
        city: "", //市
        town: "", //区
        address: "", //详细地址
        frontImage: "", //正面
        backImage: "", //反面
        handHeldImage: "", //照片
        goodsId: "", //商品id
        paymentId: "",
        orderTime: "", //预设下单时间
      };
    },
    //为客户下单
    onSubmit() {
      if (!this.info.goodsId) {
        this.$message.error("请选择商品");
        return;
      }
      if (!this.info.idCardName) {
        this.$message.error("请输入姓名");
        return;
      }
      if (!this.info.phone) {
        this.$message.error("请输入手机号");
        return;
      }
      if (!this.info.idCardNo) {
        this.$message.error("请输入身份证号码");
        return;
      }
      if (!this.info.pctIds) {
        this.$message.error("请选择地址");
        return;
      }
      if (!this.info.address) {
        this.$message.error("请填写详细地址");
        return;
      }
      if (this.isrequireIdCard && !this.info.frontImage) {
        this.$message.error("请上传身份证照片国徽图片");
        return;
      }
      if (this.isrequireIdCard && !this.info.backImage) {
        this.$message.error("请上传身份证照片人像图片");
        return;
      }
      if (this.isrequireIdCard && !this.info.handHeldImage) {
        this.$message.error("请上传免冠图片");
        return;
      }
      const isPreOrder = !!this.info.orderTime;

      // 获取选中的商品 SKU
      const selectedGoods = this.shopOptions.find(
        (item) => item.id === this.info.goodsId
      );
      const sku = selectedGoods ? selectedGoods.retailSku : "";

      // 获取 customerNo
      const customerNo =
        this.customerList.length > 0 ? this.customerList[0].customerNo : "";

      const payload = {
        idCardNo: this.info.idCardNo,
        idCardName: this.info.idCardName,
        phone: this.info.phone,
        pctIds: this.info.pctIds,
        province: this.info.province,
        city: this.info.city,
        town: this.info.town,
        address: this.info.address,
        sku: sku,
        frontImage: this.info.frontImage,
        backImage: this.info.backImage,
        handHeldImage: this.info.handHeldImage,
        customerNo: customerNo,
        serUserId: this.getServerUserId(),
        corpId: this.corpId,
      };

      if (isPreOrder) {
        payload.orderTime = this.info.orderTime;
      }

      this.btnisfell = true;

      this.$message({
        message: isPreOrder ? "正在预下单" : "正在下单",
        type: "warning",
      });

      const submitRequest = isPreOrder ? savePreOrder : replaceTheOrder;

      submitRequest(payload).then((res) => {
        if (res.code == 200) {
          this.btnisfell = false;
          this.$message({
            message: res.msg,
            type: "success",
          });
          (this.addinfo.idCardNo = this.info.idCardNo), //证件号码
            (this.addinfo.idCardName = this.info.idCardName), //证件名
            (this.addinfo.receiverTel = this.info.phone), //电话
            (this.addinfo.pctIds = this.info.pctIds), //地址id
            (this.addinfo.province = this.info.province), //省
            (this.addinfo.city = this.info.city), //市
            (this.addinfo.town = this.info.town), //区
            (this.addinfo.receiverAddr = this.info.address), //详细地址
            (this.addinfo.retailUserId = this.retailUserId);
          this.addAddress();

          // if (this.addinfo.idCardNo != this.info.idCardNo) {
          //   (this.addinfo.idCardNo = this.info.idCardNo), //证件号码
          //     (this.addinfo.idCardName = this.info.idCardName), //证件名
          //     (this.addinfo.receiverTel = this.info.phone), //电话
          //     (this.addinfo.pctIds = this.info.pctIds), //地址id
          //     (this.addinfo.province = this.info.province), //省
          //     (this.addinfo.city = this.info.city), //市
          //     (this.addinfo.town = this.info.town), //区
          //     (this.addinfo.receiverAddr = this.info.address), //详细地址
          //     (this.addinfo.retailUserId = this.retailUserId);
          //   this.addAddress();
          // } else if (this.addinfo.idCardName != this.info.idCardName) {
          //   (this.addinfo.idCardNo = this.info.idCardNo), //证件号码
          //     (this.addinfo.idCardName = this.info.idCardName), //证件名
          //     (this.addinfo.receiverTel = this.info.phone), //电话
          //     (this.addinfo.pctIds = this.info.pctIds), //地址id
          //     (this.addinfo.province = this.info.province), //省
          //     (this.addinfo.city = this.info.city), //市
          //     (this.addinfo.town = this.info.town), //区
          //     (this.addinfo.receiverAddr = this.info.address), //详细地址
          //     (this.addinfo.retailUserId = this.retailUserId);
          //   this.addAddress();
          // } else if (this.addinfo.receiverTel != this.info.phone) {
          //   (this.addinfo.idCardNo = this.info.idCardNo), //证件号码
          //     (this.addinfo.idCardName = this.info.idCardName), //证件名
          //     (this.addinfo.receiverTel = this.info.phone), //电话
          //     (this.addinfo.pctIds = this.info.pctIds), //地址id
          //     (this.addinfo.province = this.info.province), //省
          //     (this.addinfo.city = this.info.city), //市
          //     (this.addinfo.town = this.info.town), //区
          //     (this.addinfo.receiverAddr = this.info.address), //详细地址
          //     (this.addinfo.retailUserId = this.retailUserId);
          //   this.addAddress();
          // } else if (this.addinfo.pctIds != this.info.pctIds) {
          //   (this.addinfo.idCardNo = this.info.idCardNo), //证件号码
          //     (this.addinfo.idCardName = this.info.idCardName), //证件名
          //     (this.addinfo.receiverTel = this.info.phone), //电话
          //     (this.addinfo.pctIds = this.info.pctIds), //地址id
          //     (this.addinfo.province = this.info.province), //省
          //     (this.addinfo.city = this.info.city), //市
          //     (this.addinfo.town = this.info.town), //区
          //     (this.addinfo.receiverAddr = this.info.address), //详细地址
          //     (this.addinfo.retailUserId = this.retailUserId);
          //   this.addAddress();
          // } else if (this.addinfo.receiverAddr != this.info.address) {
          //   (this.addinfo.idCardNo = this.info.idCardNo), //证件号码
          //     (this.addinfo.idCardName = this.info.idCardName), //证件名
          //     (this.addinfo.receiverTel = this.info.phone), //电话
          //     (this.addinfo.pctIds = this.info.pctIds), //地址id
          //     (this.addinfo.province = this.info.province), //省
          //     (this.addinfo.city = this.info.city), //市
          //     (this.addinfo.town = this.info.town), //区
          //     (this.addinfo.receiverAddr = this.info.address), //详细地址
          //     (this.addinfo.retailUserId = this.retailUserId);
          //   this.addAddress();
          // }
          this.dialogVisible = false;
          this.lookaddShow = false;
          this.info = {
            idCardNo: "", //证件号码
            idCardName: "", //证件名
            phone: "", //电话
            pctIds: "", //地址id
            province: "", //省
            city: "", //市
            town: "", //区
            address: "", //详细地址
            frontImage: "", //正面
            backImage: "", //反面
            handHeldImage: "", //照片
            goodsId: "", //商品id
            paymentId: "",
            orderTime: "", //预设下单时间
          };
          this.addvalue = "";
          this.addressId = "";
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
          // setTimeout(() => {
          //   loading.close();
          // }, 200);
        }
      });
    },
    //检查四个参数是否齐全，如果齐全则调用获取商品列表接口
    checkAndGetGoodsList() {
      const { idCardNo, province, city, town } = this.info;
      // 检查四个参数是否全部有值（不为 undefined、null 或空字符串）
      if (idCardNo && province && city && town) {
        this.getgoodsList();
      } else {
        // 如果参数不完整，清空商品列表
        this.shopOptions = [];
      }
    },
    //获取三级地址信息
    getaddInfo() {
      const selectedNodes = this.$refs.cascaderRef.getCheckedNodes();
      // 提取 id 和 name
      const lastNode = selectedNodes[0]; // 获取最后一个选中节点
      const ids = lastNode.path; // 层级 id 数组，例如：["zhinan", "shejiyuanze", "yizhi"]
      const names = lastNode.pathLabels; // 层级 name 数组，例如：["指南", "设计原则", "一致"]
      this.info.province = "";
      this.info.city = "";
      this.info.town = "";
      this.info.pctIds = "";
      this.info.province = names[0];
      this.info.city = names[1];
      this.info.town = names[2];
      this.info.pctIds = ids.join(",");
      this.addressId = "";
      this.checkAndGetGoodsList();
    },
    //判断是不是电话号
    isPhone() {
      const isphone = /^1[3-9]\d{9}$/;
      if (!isphone.test(this.info.phone) && this.info.phone) {
        this.$message.error("手机号格式错误");
      }
      if (!isphone.test(this.addinfo.receiverTel) && this.addinfo.receiverTel) {
        this.$message.error("手机号格式错误");
      }
    },
    //获取地址列表
    getthreearea() {
      getareaLevel3().then((res) => {
        if (res.code == 200) {
          this.addoptions = this.split(res.data);
        }
      });
    },
    //判断是不是身份证
    isCard() {
      // 正则表达式（同时支持15位和18位）
      const idCardRegex =
        /(^[1-9]\d{5}(18|19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}(\d|X|x)$)|(^[1-9]\d{5}\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}$)/;
      if (!idCardRegex.test(this.info.idCardNo) && this.info.idCardNo) {
        this.$message.error("身份证格式错误");
      } else if (
        !idCardRegex.test(this.addinfo.idCardNo) &&
        this.addinfo.idCardNo
      ) {
        this.$message.error("身份证格式错误");
      } else {
        this.checkAndGetGoodsList();
      }
      // 证件号码变化后，检查是否可以获取商品列表
    },
    //地址匹配
    getaddinfo() {
      this.addressList.forEach((item) => {
        if (item.id == this.addressId) {
          console.log("this.addressId", this.addressId);
          this.info.idCardNo = item.idCardNo; //证件号码
          this.info.idCardName = item.idCardName; //证件名
          this.info.phone = item.receiverTel; //电话
          this.info.pctIds = item.pctIds; //地址id
          this.info.province = item.province; //省
          this.info.city = item.city; //市
          this.info.town = item.town; //区
          this.info.address = item.receiverAddr; //详细地址
          this.addvalue = item.pctIds.split(",").map(Number);
          console.log("pctIds", item.pctIds);

          this.addinfo.idCardNo = item.idCardNo; //证件号码
          this.addinfo.idCardName = item.idCardName; //证件名
          this.addinfo.receiverTel = item.receiverTel; //电话
          this.addinfo.pctIds = item.pctIds; //地址id
          this.addinfo.province = item.province; //省
          this.addinfo.city = item.city; //市
          this.addinfo.town = item.town; //区
          this.addinfo.receiverAddr = item.receiverAddr; //详细地址
          this.checkAndGetGoodsList();
        }
      });
    },
    // 清洗二级数据结构
    split(data) {
      let newData = [];
      data.forEach((item) => {
        let newItem = { ...item };
        if (newItem.children && newItem.children.length === 0) {
          delete newItem.children;
        } else if (newItem.children) {
          newItem.children = this.split(newItem.children);
        }
        newData.push(newItem);
      });
      return newData;
    },
    //获取商品信息
    getshopinfo() {
      this.btnisfell = false;
      this.goodsInfo = [];
      this.isrequireIdCard = false;
      this.shopOptions.forEach((item) => {
        if (this.info.goodsId == item.id) {
          if (item.requireIdCard == 1) {
            this.isrequireIdCard = true;
          }
          this.goodsInfo.push(item);
          console.log("goods", this.goodsInfo);
        }
      });
    },
    //搜索商品
    searchSelectGoods(query) {
      if (query == "") {
        if (this.clickTimer) clearTimeout(this.clickTimer);
        this.clickTimer = setTimeout(() => {
          this.getgoodsList();
        }, 300);
      } else {
        if (this.clickTimer) clearTimeout(this.clickTimer);
        this.clickTimer = setTimeout(() => {
          selectReplaceGoodslist({
            keywords: query,
            idCardNo: this.info.idCardNo,
            province: this.info.province,
            city: this.info.city,
            town: this.info.town,
          }).then((res) => {
            this.shopOptions = res.rows;
          });
        }, 500);
      }
    },
    //获取商品列表
    getgoodsList() {
      const { idCardNo, province, city, town } = this.info;
      // 验证四个参数是否全部存在且不为空
      if (!idCardNo || !province || !city || !town) {
        console.log("参数不完整，无法获取商品列表", {
          idCardNo,
          province,
          city,
          town,
        });
        this.shopOptions = []; // 清空商品列表
        return;
      }

      console.log("获取商品列表，参数:", { idCardNo, province, city, town });
      // 四个参数全部满足，调用接口
      const params = {
        idCardNo: idCardNo,
        province: province,
        city: city,
        town: town,
      };

      selectReplaceGoodslist(params)
        .then((res) => {
          if (res.code == 200) {
            console.log("获取商品列表成功", res);
            this.shopOptions = res.rows;
          }
        })
        .catch((err) => {
          console.error("获取商品列表失败:", err);
          this.shopOptions = []; // 请求失败时清空商品列表
        });
    },
    //获取收货列表
    getreceiverList(customerNo) {
      receiverList(customerNo).then((res) => {
        // 排序：默认地址(isDefault=1)优先，其次按姓名排序
        const sortedList = (res.data || []).sort((a, b) => {
          // 默认地址优先
          if (a.isDefault == 1 && b.isDefault != 1) return -1;
          if (a.isDefault != 1 && b.isDefault == 1) return 1;
          // 按姓名排序
          return (a.idCardName || "").localeCompare(
            b.idCardName || "",
            "zh-CN"
          );
        });
        this.addressList = sortedList;
      });
    },

    // 加载客户列表
    async loadCustomerList() {
      this.loading = true;
      try {
        const context = await this.waitForCustomerContext();

        if (!context.corpId || !context.qwUserId || !context.serverUserId) {
          this.customerList = [];
          return;
        }

        clearCustomerInfoCache();

        const response = await getCustomerInfo({
          corpId: context.corpId,
          customerUserId: context.qwUserId,
          serUserId: context.serverUserId,
        });

        console.log("客户信息响应:", response);

        let customers = [];
        if (response && response.code === 200 && response.data) {
          const customerData = response.data;

          // 构造客户对象
          const customer = {
            // 用于 Vue 的 key
            id: customerData.customerNo,
            userId: context.qwUserId,
            // 业务字段
            customerNo: customerData.customerNo,
            remark: customerData.remark,
            serUserId: customerData.serUserId,
            serUserName: customerData.serUserName,
            retailUserId: context.qwUserId,
            // 模板中使用的字段
            avatar: null,
            corpName: null,
            idCardName: null,
            name: customerData.remark,
            userName: customerData.remark,
            // 构造 ser 对象（专属客服信息）
            ser: {
              username: customerData.serUserName,
              userId: customerData.serUserId,
            },
          };
          customers.push(customer);

          // 获取收货地址列表
          const addrRes = await receiverList(customerData.customerNo);
          if (addrRes && addrRes.code === 200 && addrRes.data) {
            const sortedList = (addrRes.data || []).sort((a, b) => {
              if (a.isDefault == 1 && b.isDefault != 1) return -1;
              if (a.isDefault != 1 && b.isDefault == 1) return 1;
              return (a.idCardName || "").localeCompare(
                b.idCardName || "",
                "zh-CN"
              );
            });
            this.addressList = sortedList;

            // 设置默认地址
            const defaultAddr =
              sortedList.find((addr) => addr.isDefault == 1) ||
              sortedList[0] ||
              null;
            if (defaultAddr) {
              this.$set(customer, "defaultAddress", defaultAddr);
              // 从默认地址获取客户姓名
              if (defaultAddr.idCardName) {
                customer.idCardName = defaultAddr.idCardName;
              }
            }
          }
        }

        this.customerList = customers;

        console.log(`加载客户成功，共 ${this.customerList.length} 条数据`);

        // 加载已分配的客户标签
        if (customers.length > 0 && context.corpId && context.qwUserId) {
          this.loadAssignedTags({
            corpId: context.corpId,
            customerUserId: context.qwUserId,
            serUserId: context.serverUserId,
          });
        } else {
          this.assignedTags = [];
        }
      } catch (error) {
        console.error("获取客户信息失败:", error);
        this.$message.error(`获取客户信息失败: ${error.message}`);
        this.customerList = [];
      } finally {
        this.loading = false;
      }
    },

    // 复制文本
    copyText(text) {
      if (navigator.clipboard) {
        navigator.clipboard
          .writeText(text)
          .then(() => {
            this.$message.success("复制成功");
          })
          .catch(() => {
            this.fallbackCopy(text);
          });
      } else {
        this.fallbackCopy(text);
      }
    },

    // 备用复制方法
    fallbackCopy(text) {
      const textArea = document.createElement("textarea");
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand("copy");
        this.$message.success("复制成功");
      } catch (err) {
        this.$message.error("复制失败，请手动复制");
      }
      document.body.removeChild(textArea);
    },

    // 获取头像文字
    getAvatarText(name) {
      if (!name) return "客";
      return name.charAt(0).toUpperCase();
    },

    // 复制收件信息
    copyReceiverInfo(address) {
      if (!address) return;
      const fullAddress = `${address.province || ""}${address.city || ""}${
        address.town || ""
      } ${address.receiverAddr || ""}`;
      const info = `姓名：${address.idCardName || ""}\n收件手机号：${
        address.receiverTel || ""
      }\n身份证号：${address.idCardNo || ""}\n收货地址：${fullAddress}`;
      this.copyText(info);
    },

    // 处理图片加载错误
    handleImageError(event) {
      event.target.style.display = "none";
      event.target.nextElementSibling.style.display = "flex";
    },

    // 格式化日期
    formatDate(dateString) {
      if (!dateString) return "";
      const date = new Date(dateString);
      return date.toLocaleString("zh-CN");
    },

    // 关闭下单弹窗
    handleCloseOrderDialog() {
      this.dialogVisible = false;
      this.close();
    },

    // iOS 级联选择器触摸时展开
    handleCascaderTouch() {
      const cascaderRef = this.$refs.cascaderRef;
      if (cascaderRef) {
        setTimeout(() => {
          cascaderRef.toggleDropDownVisible(true);
        }, 100);
      }
    },

    // iOS 地址选择器触摸时展开
    handleAddressSelectTouch() {
      const selectRef = this.$refs.addressSelectRef;
      if (selectRef) {
        setTimeout(() => {
          selectRef.focus();
          selectRef.visible = true;
        }, 100);
      }
    },

    // 添加地址
    addAddress() {
      // 从第一个客户获取 customerNo
      const customerNo =
        this.customerList.length > 0 ? this.customerList[0].customerNo : "";
      if (!customerNo) {
        this.$message.error("未获取到客户编号");
        return;
      }

      const payload = {
        customerNo,
        idCardNo: this.addinfo.idCardNo,
        idCardName: this.addinfo.idCardName,
        receiverTel: this.addinfo.receiverTel,
        pctIds: this.addinfo.pctIds,
        province: this.addinfo.province,
        city: this.addinfo.city,
        town: this.addinfo.town,
        receiverAddr: this.addinfo.receiverAddr,
      };

      addReceiver(payload)
        .then((res) => {
          if (res.code === 200) {
            this.getreceiverList(customerNo);
          } else {
            this.$message.error(res.msg || "新增地址失败");
          }
        })
        .catch((err) => {
          console.error("新增地址失败:", err);
          this.$message.error("新增地址失败");
        });
    },

    // 获取完整地址标签（用于选中状态显示）
    getFullAddressLabel(item) {
      const location = `${item.province}${item.city}${item.town}`;
      const address = item.receiverAddr || "";
      const name = item.idCardName || "未知";
      const phone = item.receiverTel || "";

      // 完整地址 - 姓名 - 电话
      return `${location}${address} - ${name} - ${phone}`;
    },

    // 获取商品标签（用于选中状态显示）
    getGoodsLabel(item) {
      const title = item.title || "未知商品";
      const price = item.price || "0";
      const sku = item.retailSku || "";

      // 商品名称 - 价格 - SKU
      return `${title} - ¥${price}${sku ? " - " + sku : ""}`;
    },

    // 显示联系提醒弹窗
    showReminderDialog(customer) {
      this.selectedCustomerForReminder = customer;
      this.reminderForm = {
        customerRemark: customer.remark || customer.idCardName || "",
        reminderTime: "",
        noticeContent: "",
      };
      this.reminderDialogVisible = true;
    },

    // 关闭联系提醒弹窗
    handleCloseReminderDialog() {
      this.reminderDialogVisible = false;
      this.selectedCustomerForReminder = null;
      this.resetReminderForm();
    },

    // 重置提醒表单
    resetReminderForm() {
      if (this.$refs.reminderForm) {
        this.$refs.reminderForm.resetFields();
      }
      this.reminderForm = {
        customerRemark: "",
        reminderTime: "",
        noticeContent: "",
      };
    },

    // 提交联系提醒
    async submitReminder() {
      if (!this.$refs.reminderForm) {
        this.$message.error("表单引用不存在");
        return;
      }

      try {
        // 表单验证
        await this.$refs.reminderForm.validate();

        this.reminderSubmitting = true;

        const params = {
          corpId: this.corpId,
          serUserId: this.getServerUserId(), // 修复：使用客服ID而不是用户ID
          customerRemark: this.reminderForm.customerRemark,
          reminderTime: this.reminderForm.reminderTime,
          noticeContent: this.reminderForm.noticeContent,
        };

        console.log("提交联系提醒参数:", params);

        const response = await addLinkAlert(params);
        console.log("联系提醒响应:", response);

        this.$message.success("联系提醒设置成功！");
        this.handleCloseReminderDialog();
      } catch (error) {
        console.error("设置联系提醒失败:", error);

        if (error.message && error.message.includes("validate")) {
          // 表单验证失败，不显示错误消息，Element UI会自动显示
          return;
        }

        const errorMessage =
          error.response?.data?.message || error.message || "设置联系提醒失败";
        this.$message.error(errorMessage);
      } finally {
        this.reminderSubmitting = false;
      }
    },

    // 加载客户已分配的标签
    async loadAssignedTags(params) {
      this.tagListLoading = true;
      try {
        const res = await getCustomerTagList(params);
        if (res && res.code === 200 && Array.isArray(res.data)) {
          this.assignedTags = res.data;
        } else {
          this.assignedTags = [];
        }
      } catch (error) {
        console.error("加载客户标签失败:", error);
        this.assignedTags = [];
      } finally {
        this.tagListLoading = false;
      }
    },

    // 打开标签编辑器
    async openTagEditor() {
      const context = await this.waitForCustomerContext();
      if (!context.corpId || !context.qwUserId || !context.serverUserId) {
        this.$message.warning("客户上下文尚未就绪，请稍后再试");
        return;
      }

      // 预填当前已选标签
      this.selectedTagIds = this.assignedTags.map((t) => t.tagId || t.id);

      this.tagDialogVisible = true;
      this.tagOptionsLoading = true;
      try {
        const res = await getCustomerTagOptions({
          corpId: context.corpId,
        });
        const list =
          res && res.code === 200 && Array.isArray(res.data) ? res.data : [];
        this.allTagOptions = list;
        this.tagOptions = list;
      } catch (error) {
        console.error("加载可选标签失败:", error);
        this.$message.error("加载可选标签失败");
        this.allTagOptions = [];
        this.tagOptions = [];
      } finally {
        this.tagOptionsLoading = false;
      }
    },

    // 关闭标签编辑器
    handleCloseTagDialog() {
      this.tagDialogVisible = false;
      this.selectedTagIds = [];
    },

    // 过滤可选标签(本地过滤，避免每次输入都请求)
    filterTagOptions(query) {
      if (!query) {
        // 清空搜索时恢复全部
        this.tagOptions = this.allTagOptions.slice();
        return;
      }
      const lc = String(query).toLowerCase();
      this.tagOptions = this.allTagOptions.filter((opt) => {
        const name = (opt.tagName || opt.name || "").toLowerCase();
        return name.includes(lc);
      });
    },

    // 提交标签覆盖更新
    async submitCustomerTags() {
      const context = await this.waitForCustomerContext();
      if (!context.corpId || !context.qwUserId || !context.serverUserId) {
        this.$message.warning("客户上下文尚未就绪，请稍后再试");
        return;
      }

      this.tagSubmitting = true;
      try {
        const payload = {
          corpId: context.corpId,
          customerUserId: context.qwUserId,
          serUserId: context.serverUserId,
          tagIds: this.selectedTagIds || [],
        };
        const res = await updateCustomerTags(payload);
        if (res && res.code === 200) {
          this.$message.success(res.msg || "标签更新成功");
          this.tagDialogVisible = false;
          // 刷新已分配标签
          await this.loadAssignedTags({
            corpId: context.corpId,
            customerUserId: context.qwUserId,
            serUserId: context.serverUserId,
          });
        } else {
          this.$message.error((res && res.msg) || "标签更新失败");
        }
      } catch (error) {
        console.error("更新客户标签失败:", error);
        const msg =
          (error && error.response && error.response.data && error.response.data.message) ||
          (error && error.message) ||
          "标签更新失败";
        this.$message.error(msg);
      } finally {
        this.tagSubmitting = false;
      }
    },

    // 标签颜色（按名字散列到 element-ui 的 6 种 type 中）
    getTagType(tag) {
      const types = ["", "success", "info", "warning", "danger"];
      const name = tag.tagName || tag.name || "";
      let hash = 0;
      for (let i = 0; i < name.length; i++) {
        hash = (hash * 31 + name.charCodeAt(i)) >>> 0;
      }
      return types[hash % types.length];
    },
  },
};
</script>

<style>
/* 全局字体加粗 */
.customer-list {
  font-weight: 600;
}

.customer-list *,
.customer-list .el-button,
.customer-list .el-input__inner,
.customer-list .el-select .el-input__inner,
.customer-list .el-table,
.customer-list .el-table th,
.customer-list .el-table td,
.customer-list .el-form-item__label,
.customer-list .el-dialog__title,
.customer-list .el-dialog__body,
.customer-list .el-cascader .el-input__inner {
  font-weight: 600 !important;
}

/* 弹窗内容字体加粗 */
.el-dialog .el-dialog__title,
.el-dialog .el-dialog__body,
.el-dialog .el-dialog__body *,
.el-dialog .el-button,
.el-dialog .el-form-item__label,
.el-dialog .el-input__inner,
.el-dialog .el-select .el-input__inner,
.el-dialog .el-table,
.el-dialog .el-table th,
.el-dialog .el-table td {
  font-weight: 600 !important;
}

/* 全局样式 - 地址选择下拉框优化 */
.address-select-dropdown {
  min-width: 600px !important;
  max-width: 800px !important;
}

.address-select-dropdown .el-select-dropdown__item {
  height: auto !important;
  min-height: auto !important;
  padding: 8px 15px !important;
  line-height: 1.4 !important;
  white-space: normal !important;
  border-bottom: 1px solid #e8eaec;
}

.address-select-dropdown .el-select-dropdown__item:last-child {
  border-bottom: none;
}

.address-select-dropdown .el-select-dropdown__item.hover,
.address-select-dropdown .el-select-dropdown__item:hover {
  background-color: #f8f9ff !important;
}

.address-select-dropdown .el-select-dropdown__item.selected {
  background-color: #ecf5ff !important;
  color: #409eff !important;
}

.address-select-dropdown .el-select-dropdown__item * {
  font-weight: 600 !important;
}

/* 商品选择下拉框优化 */
.goods-select-dropdown {
  min-width: 550px !important;
  max-width: 750px !important;
}

.goods-select-dropdown .el-select-dropdown__item {
  height: auto !important;
  min-height: 110px !important;
  padding: 15px 20px !important;
  line-height: 1.5 !important;
  white-space: normal !important;
  border-bottom: 1px solid #e8eaec;
}

.goods-select-dropdown .el-select-dropdown__item:last-child {
  border-bottom: none;
}

.goods-select-dropdown .el-select-dropdown__item.hover,
.goods-select-dropdown .el-select-dropdown__item:hover {
  background-color: #f8f9ff !important;
}

.goods-select-dropdown .el-select-dropdown__item.selected {
  background-color: #ecf5ff !important;
  color: #409eff !important;
}

.goods-select-dropdown .el-select-dropdown__item * {
  font-weight: 600 !important;
}

.customer-list {
  padding: 20px;
  background: #fff;
  border-radius: 4px;
}

.list-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.list-header h3 {
  margin: 0;
  color: #303133;
}

.header-actions {
  display: flex;
  gap: 10px;
  align-items: center;
}

.loading-container {
  text-align: center;
  padding: 40px 0;
  color: #909399;
}

.loading-container i {
  font-size: 24px;
  margin-bottom: 10px;
}

.empty-container {
  padding: 40px 0;
}

.customer-container {
  margin-top: 20px;
}

.customer-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
}

.customer-card {
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  padding: 20px;
  background: #fff;
  transition: all 0.3s ease;
  cursor: pointer;
}

.customer-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border-color: #409eff;
}

.customer-avatar {
  display: flex;
  justify-content: center;
  margin-bottom: 15px;
}

.customer-avatar img {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  object-fit: cover;
}

.avatar-placeholder,
.avatar-placeholder-large {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #409eff;
  color: white;
  font-weight: bold;
  border-radius: 50%;
}

.avatar-placeholder {
  width: 60px;
  height: 60px;
  font-size: 24px;
}

.avatar-placeholder-large {
  width: 80px;
  height: 80px;
  font-size: 32px;
}

.customer-info {
  text-align: center;
  margin-bottom: 15px;
}

.customer-name {
  font-size: 16px;
  font-weight: 500;
  color: #303133;
  margin-bottom: 8px;
}

/* 客户详情内联显示样式 */
.customer-detail-inline {
  text-align: left;
  margin-top: 10px;
  padding: 10px;
  background: #f8f9fa;
  border-radius: 6px;
}

.customer-detail-inline .detail-item {
  display: flex;
  align-items: center;
  font-size: 13px;
  margin-bottom: 6px;
}

.customer-detail-inline .detail-item:last-child {
  margin-bottom: 0;
}

.customer-detail-inline .detail-label {
  color: #909399;
  flex-shrink: 0;
  min-width: 70px;
}

.customer-detail-inline .detail-value {
  color: #606266;
  word-break: break-all;
}

.customer-detail-inline .copy-action {
  margin-top: 8px;
  justify-content: center;
}

.customer-detail-inline .detail-item-tags {
  align-items: flex-start;
}

.customer-detail-inline .tag-list {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
}

.customer-detail-inline .tag-empty {
  color: #c0c4cc;
  font-size: 13px;
  margin-right: 8px;
}

.customer-detail-inline .customer-tag-chip {
  font-weight: 500 !important;
}

.customer-detail-inline .tag-edit-btn {
  margin-left: 4px;
}

.tag-dialog-customer {
  color: #303133;
  font-size: 14px;
}

.tag-dialog-hint {
  margin-top: 8px;
  color: #909399;
  font-size: 12px;
  line-height: 1.4;
}

/* 标签下拉框样式（参考地址/商品下拉框视觉） */
.tag-select-dropdown {
  min-width: 320px !important;
  max-width: 480px !important;
}

.tag-select-dropdown .el-select-dropdown__item {
  font-weight: 600 !important;
}

/* 联系提醒弹窗样式 */
.reminder-form {
  padding: 0;
}

.customer-info-header {
  display: flex;
  align-items: center;
  padding: 16px;
  background: #f8f9fa;
  border-radius: 8px;
  margin-bottom: 20px;
}

.customer-avatar-small {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 12px;
  flex-shrink: 0;
}

.customer-avatar-small img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.avatar-placeholder-small {
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 600;
  font-size: 14px;
}

.customer-info-text {
  flex: 1;
}

.customer-name-small {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 4px;
}

.reminder-form-content {
  padding: 0;
}

.customer-detail {
  padding: 20px 0;
}

.detail-header {
  display: flex;
  align-items: center;
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 1px solid #e4e7ed;
}

.detail-avatar {
  margin-right: 20px;
}

.detail-avatar img {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  object-fit: cover;
}

.detail-name {
  font-size: 20px;
  font-weight: 500;
  color: #303133;
}

.detail-content {
  margin-top: 20px;
}

.detail-section {
  margin-bottom: 30px;
}

.detail-section h4 {
  margin: 0 0 15px 0;
  color: #303133;
  font-size: 16px;
  font-weight: 500;
}

.detail-grid {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.detail-row {
  display: flex;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #f5f7fa;
}

.detail-label {
  min-width: 120px;
  color: #606266;
  font-weight: 500;
}

.detail-value {
  flex: 1;
  color: #303133;
  margin-right: 10px;
  word-break: break-all;
}

.copy-btn {
  padding: 0;
  font-size: 12px;
}

.dialog-footer {
  text-align: right;
}

.tableImg {
  width: 80px;
  height: 80px;
  object-fit: cover;
  border-radius: 4px;
}

/* 地址选项完整显示样式 */
.address-option-full {
  padding: 4px 0;
  line-height: 1.5;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.address-row {
  display: block;
  font-size: 13px;
  color: #303133;
  white-space: nowrap;
}

.address-row.address-detail {
  font-size: 12px;
  color: #909399;
  white-space: nowrap;
}

.address-label {
  min-width: 60px;
  font-weight: 600;
  color: #606266;
  font-size: 13px;
  flex-shrink: 0;
  margin-right: 8px;
}

.address-content {
  flex: 1;
  color: #303133;
  font-size: 13px;
  line-height: 1.2;
  word-wrap: break-word;
  word-break: break-all;
  white-space: normal;
}

/* 商品选项完整显示样式 */
.goods-option-full {
  padding: 5px 0;
  line-height: 1.6;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.goods-row {
  display: flex;
  align-items: flex-start;
  min-height: 20px;
}

.goods-label {
  min-width: 70px;
  font-weight: 600;
  color: #606266;
  font-size: 13px;
  flex-shrink: 0;
  margin-right: 8px;
}

.goods-content {
  flex: 1;
  color: #303133;
  font-size: 13px;
  line-height: 1.5;
  word-wrap: break-word;
  word-break: break-all;
  white-space: normal;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .customer-grid {
    grid-template-columns: 1fr;
  }

  .detail-row {
    flex-direction: column;
    align-items: flex-start;
  }

  .detail-label {
    min-width: auto;
    margin-bottom: 5px;
  }

  .detail-value {
    margin-right: 0;
    margin-bottom: 5px;
  }
}

@media (max-width: 480px) {
  .customer-list {
    padding: 15px;
  }

  .list-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
  }

  .header-actions {
    width: 100%;
  }

  /* 移动端下拉框优化 */
  .address-select-dropdown {
    min-width: 350px !important;
    max-width: 450px !important;
  }

  .address-select-dropdown .el-select-dropdown__item {
    min-height: auto !important;
    padding: 8px 12px !important;
  }

  .goods-select-dropdown {
    min-width: 320px !important;
    max-width: 420px !important;
  }

  .goods-select-dropdown .el-select-dropdown__item {
    min-height: 120px !important;
    padding: 12px 15px !important;
  }

  .address-option-full {
    gap: 6px;
  }

  .address-label {
    min-width: 50px;
    font-size: 12px;
  }

  .address-content {
    font-size: 12px;
  }

  .goods-option-full {
    gap: 6px;
  }

  .goods-label {
    min-width: 60px;
    font-size: 12px;
  }

  .goods-content {
    font-size: 12px;
  }
}

/* y-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid #ebeef5;
} */

.list-header h3 {
  margin: 0;
  color: #303133;
  font-size: 20px;
  font-weight: 500;
}

.header-actions {
  display: flex;
  gap: 10px;
}

.loading-container {
  text-align: center;
  padding: 50px;
  color: #909399;
}

.loading-container i {
  font-size: 26px;
  margin-bottom: 10px;
}

.empty-container {
  padding: 50px;
}

.customer-container {
  min-height: 400px;
}

.customer-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 16px;
  margin-bottom: 20px;
}

.customer-card {
  border: 1px solid #dcdfe6;
  border-radius: 8px;
  padding: 16px;
  background: white;
  transition: all 0.2s ease;
  display: flex;
  flex-direction: column;
}

.customer-card:hover {
  border-color: #409eff;
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.1);
}

.customer-avatar {
  display: flex;
  justify-content: center;
  margin-bottom: 12px;
}

.customer-avatar img {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #f0f0f0;
}

.avatar-placeholder {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: linear-gradient(135deg, #409eff, #67c23a);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 26px;
  font-weight: bold;
}

.customer-info {
  flex: 1;
  margin-bottom: 12px;
}

.customer-name {
  font-size: 18px;
  font-weight: 500;
  color: #303133;
  text-align: center;
  margin-bottom: 12px;
}

.customer-details {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.detail-item {
  display: flex;
  align-items: center;
  font-size: 15px;
  line-height: 1.4;
}

.detail-item .label {
  color: #909399;
  min-width: 70px;
  font-weight: 500;
}

.detail-item .value {
  color: #303133;
  flex: 1;
  margin-right: 8px;
  word-break: break-all;
}

.copy-btn {
  padding: 2px 6px;
  color: #409eff;
  font-size: 13px;
  border-radius: 2px;
  background: transparent;
  flex-shrink: 0;
}

.copy-btn:hover {
  background: #409eff;
  color: white;
}

/* 响应式设计 */

/* 响应式布局 - 桌面端 */
@media (min-width: 768px) {
  .customer-list {
    padding: 20px;
  }

  .list-header h3 {
    font-size: 18px;
  }

  .customer-grid {
    grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
    gap: 16px;
  }

  .customer-name {
    font-size: 16px;
  }

  .detail-item {
    font-size: 13px;
  }

  .detail-label {
    font-size: 13px;
  }

  .detail-value {
    font-size: 13px;
  }

  .detail-name {
    font-size: 20px;
  }

  .detail-row {
    font-size: 14px;
  }
}

/* 企业微信侧边栏适配 - 移动端 */
@media (max-width: 400px) {
  .customer-list {
    padding: 6px;
  }

  .list-header h3 {
    font-size: 12px;
  }

  .customer-grid {
    grid-template-columns: 1fr;
    gap: 6px;
  }

  .customer-card {
    padding: 8px;
  }

  .customer-avatar img,
  .avatar-placeholder {
    width: 35px;
    height: 35px;
    font-size: 14px;
  }

  .customer-name {
    font-size: 11px;
    margin-bottom: 6px;
  }

  .detail-item {
    font-size: 9px;
  }

  .detail-item .label {
    font-size: 9px;
    min-width: auto;
  }

  .detail-item .value {
    font-size: 9px;
  }

  .copy-btn {
    font-size: 8px;
    padding: 1px 3px;
  }

  .list-header {
    flex-direction: column;
    gap: 8px;
    align-items: flex-start;
  }

  .detail-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;
    font-size: 12px;
  }

  .detail-label {
    font-size: 9px;
    min-width: auto;
  }

  .detail-value {
    font-size: 10px;
  }

  .detail-header {
    margin-bottom: 8px;
    padding-bottom: 6px;
  }

  .detail-avatar img,
  .avatar-placeholder-large {
    width: 40px;
    height: 40px;
    font-size: 16px;
  }

  .detail-name {
    font-size: 12px;
  }

  .detail-section h4 {
    font-size: 13px;
  }
}

/* 中等屏幕适配 */
@media (min-width: 401px) and (max-width: 767px) {
  .customer-list {
    padding: 15px;
  }

  .list-header h3 {
    font-size: 16px;
  }

  .customer-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .customer-name {
    font-size: 14px;
  }

  .detail-item {
    font-size: 12px;
  }

  .detail-item .label {
    font-size: 12px;
  }

  .detail-item .value {
    font-size: 12px;
  }

  .list-header {
    flex-direction: column;
    gap: 10px;
    align-items: flex-start;
  }

  .detail-label {
    font-size: 12px;
  }

  .detail-value {
    font-size: 12px;
  }
}

/* 侧边栏模式优化 */
@media (max-width: 1200px) {
  .detail-content {
    max-height: 350px;
  }
}

/* ========== 自定义全屏弹窗样式 - iOS 兼容 ========== */
.cascader-wrapper,
.select-wrapper {
  width: 100%;
}

.custom-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 2000;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 10px;
  box-sizing: border-box;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.custom-modal {
  background: #fff;
  border-radius: 8px;
  width: 100%;
  max-width: 500px;
  max-height: calc(100vh - 20px);
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  margin: auto;
}

.custom-modal-large {
  max-width: 600px;
}

.custom-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #e4e7ed;
  flex-shrink: 0;
}

.custom-modal-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.custom-modal-close {
  font-size: 24px;
  color: #909399;
  cursor: pointer;
  line-height: 1;
  padding: 4px;
}

.custom-modal-close:hover {
  color: #409eff;
}

.custom-modal-body {
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 16px;
  overscroll-behavior: contain;
}

.custom-modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 12px 16px;
  border-top: 1px solid #e4e7ed;
  flex-shrink: 0;
}

/* 移动端自定义弹窗优化 */
@media (max-width: 480px) {
  .custom-modal-overlay {
    padding: 0;
    align-items: stretch;
  }

  .custom-modal {
    max-width: 100%;
    max-height: 100vh;
    border-radius: 0;
    margin: 0;
  }

  .custom-modal-header {
    padding: 10px 12px;
  }

  .custom-modal-title {
    font-size: 14px;
  }

  .custom-modal-body {
    padding: 12px;
  }

  .custom-modal-footer {
    padding: 10px 12px;
  }

  .custom-modal-footer .el-button {
    padding: 8px 16px;
    font-size: 13px;
  }
}
</style>
